<div class="container">
    <mat-toolbar>
        <button mat-icon-button (click)="backToLogin()">
            <mat-icon>arrow_back</mat-icon>
        </button>
        <span>Register new account</span>
    </mat-toolbar>

    <form [formGroup]="formGroup" (submit)="register()">
        <h2>Contact info</h2>

        <mat-form-field appearance="fill">
            <mat-label>Name</mat-label>
            <input matInput placeholder="Name" formControlName="name">
            <mat-icon matSuffix>person</mat-icon>
            <mat-error *ngIf="showFieldError('name')">
                Contact name is a required field
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>E-mail</mat-label>
            <input matInput placeholder="E-mail" formControlName="email">
            <mat-icon matSuffix>email</mat-icon>
            <mat-error *ngIf="showFieldError('email')">
                A valid contact e-mail is required
            </mat-error>
        </mat-form-field>

        <h2>Company details</h2>

        <mat-form-field appearance="fill">
            <mat-label>Company Legal Name</mat-label>
            <input matInput placeholder="Company Legal Name" formControlName="companyLegalName">
            <mat-icon matSuffix>business</mat-icon>
            <mat-error *ngIf="showFieldError('companyLegalName')">
                Company legal name is a required field
            </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" [ngClass]="{ 'disabled': formGroup.value.notApplicable }">
            <mat-label>Company Register Number (VAT)</mat-label>
            <input matInput placeholder="Company Register Number (VAT)" formControlName="companyRegisterNumber">
            <mat-icon matSuffix>pin</mat-icon>
            <mat-error *ngIf="showFieldError('companyRegisterNumber')">
                If applicable, company register number is a required field
            </mat-error>
        </mat-form-field>

        <mat-checkbox formControlName="notApplicable" (ngModelChange)="toggleNotApplicable()">
            Not Applicable
        </mat-checkbox>

        <button mat-raised-button color="accent" type="submit" [disabled]="requestingAccess">
            Register
        </button>
    </form>
</div>  